import { get, ref } from "firebase/database";
import * as actionType from "../../context/actions";
import { database } from "../../Utils/firebase";
import GetAssignerUserItemData from "../Firebase/AssignerUser/Items/GetAssignerUserItemDataInFirebase";

const GetItemData = async (state, dispatch, datas, sharedBusinesses = null, sharedInvoices = null) => {
    if (!state?.USERID) return null;

    try {
        const solditemref = ref(database, `invoiceGenerator/users/${state?.USERID}/items`);
        const solditemsnapshot = await get(solditemref);
        const data = solditemsnapshot.val();
        let allFetchedItems = [];
        if (data) {
            const soldItemsMap = new Map();
            Object.entries(data).forEach(([id, info]) => {
                // Each 'info' is a single item, not an array
                const price = (parseFloat(info.defaultPrice) || 0).toFixed(2);
                const key = `${info.itemId}-${info.name}-${price}`; // Unique key for grouping

                if (!soldItemsMap.has(key)) {
                    // First occurrence, initialize
                    soldItemsMap.set(key, {
                        companyId: info.companyId,
                        name: info.name,
                        price: price,
                        date: info.createdDate || "", // Use 'createdDate' as fallback
                        subtitle: info.subtitle || "",
                        itemId: info?.itemId || "",
                        isShared: false
                    });
                } else {
                    const existingItem = soldItemsMap.get(key);
                    soldItemsMap.set(key, {
                        ...existingItem,
                        invoiceIds: info.invoiceId
                            ? Array.from(new Set([...existingItem.invoiceIds, info.invoiceId])) // Avoid duplicates
                            : existingItem.invoiceIds,
                        date: info.createdDate && (!existingItem.date || new Date(info.createdDate) > new Date(existingItem.date))
                            ? info.createdDate // Keep the latest date
                            : existingItem.date
                    });
                }
            });
            allFetchedItems = Array.from(soldItemsMap.values());
        }

        /* -------- FETCH SHARED ITEMS -------- */
        const businessesToUse = sharedBusinesses || state?.ASSIGNERUSERBUSINESSES || [];
        if (businessesToUse.length) {
            const sharedItems = await GetAssignerUserItemData(state, dispatch, businessesToUse);
            allFetchedItems = [
                ...allFetchedItems,
                ...sharedItems
            ];
        }

        // Convert map to array and add serial numbers
        const finalItems = allFetchedItems.map((item, index) => ({
            srNo: index + 1,
            ...item
        }));

        dispatch({ type: actionType.ITEMS, payload: finalItems });

        return finalItems;

    } catch (error) {
        console.error("Error fetching sold items data:", error);
        return null;
    }
};

export default GetItemData;
